module.exports = __webpack_public_path__ + "static/media/contador_personas.b62e0828.jpg";